var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{staticClass:"q-pa-md",staticStyle:{"border-color":"#0086e6"},attrs:{"flat":"","bordered":""}},[_c('p',{staticClass:"text-body1 text-bold"},[_vm._v(_vm._s(_vm.title))]),_c('canvas',{attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }